import "../css/styles.css";

// Modules
// ---------------------------------
import Analytics from "./analytics";
import RudderstackTracking from "./rudderstack";

// Components
// ---------------------------------
import AppWalkthrough from "./components/app-walkthrough";
import Awards from "./components/awards";
import Blog from "./components/blog";
import CX from "./components/customer-experience";
import Clocks from "./components/clocks";
import Download from "./components/download";
import FAQ from "./components/faq";
import FactsCarousel from "./components/facts-carousel";
import FirebaseAnalytics from "./components/firebase-analytics";
import GDPR from "./components/gdpr";
import HeroWithNavigation from "./components/hero-with-navigation";
import LnerExperience from "./components/lner-experience";
import Logos from "./components/logos";
import MainMenu from "./components/main-menu";
import MobileMenu from "./components/mobile-menu";
import NewsletterForm from "./components/newsletter-form";
import NumberStats from "./components/number-stats";
import PartnerForm from "./components/partner-form";
import PartnersCarousel from "./components/partners-carousel";
import Popups from "./components/popups";
import RecentPressArticles from "./components/recent-press-articles";
import Reviews from "./components/reviews";
import Scroller from "./components/scroller";
import Share from "./components/share";
import SocialQuotes from "./components/social-quotes";
import Waypoints from "./components/waypoints";

// Helpers
// ---------------------------------
import { enableJS } from "./utils";
import {
  appInstallAppStoreUrl,
  appInstallPlayStoreUrl,
} from "./app-store-urls";

/**
 * @class App
 * A basic class to hold instances of modules
 * Any other global config can be setup here
 */
class App {
  constructor() {
    // Helpers
    // ---------------------------------
    enableJS();
    new Analytics();
    new RudderstackTracking();

    // Components
    // ---------------------------------
    new AppWalkthrough();
    new Awards();
    new Blog();
    new CX();
    new Clocks();
    new Download();
    new FAQ();
    new FactsCarousel();
    new FirebaseAnalytics();
    new GDPR();
    new HeroWithNavigation();
    new LnerExperience();
    new Logos();
    new MainMenu();
    new MobileMenu();
    new NewsletterForm();
    new NumberStats();
    new PartnerForm();
    new PartnersCarousel();
    new Popups();
    new RecentPressArticles();
    new Reviews();
    new Scroller();
    new Share();
    new SocialQuotes();
    new Waypoints();

    window.dispatchEvent(new Event("scroll"));

    if (window.location.hash) {
      setTimeout(() => {
        const hash = window.location.hash;
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView();
        }
      }, 500);
    }

    for (let element of document.querySelectorAll(
      '[data-link-type="appstore"]',
    )) {
      element.href = appInstallAppStoreUrl;
    }

    for (let element of document.querySelectorAll(
      '[data-link-type="playstore"]',
    )) {
      element.href = appInstallPlayStoreUrl;
    }
  }
}

// Ready
// ---------------------------------
document.addEventListener("DOMContentLoaded", () => new App());
